import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

export default function LakeBanner() {
  const { t } = useTranslation();
  return (
    <section
      data-testid="lake-banner"
      className="relative h-[70vh] min-h-[480px] w-full overflow-hidden"
      style={{
        backgroundImage:
          "linear-gradient(180deg, rgba(10,27,53,0.25) 0%, rgba(10,27,53,0.55) 100%), url('https://customer-assets.emergentagent.com/job_vivendi-sailing/artifacts/85ghs63l_20260529_131343.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="grain absolute inset-0 pointer-events-none" />
      <div className="relative z-10 max-w-[1400px] mx-auto h-full px-6 lg:px-12 flex flex-col justify-center items-center text-center text-white">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="w-10 h-px bg-[#D1BFAe]" />
            <span className="overline text-[#D1BFAe]">{t("banner.eyebrow")}</span>
            <span className="w-10 h-px bg-[#D1BFAe]" />
          </div>
          <h2 className="font-serif-display text-5xl sm:text-6xl lg:text-8xl leading-[1] max-w-4xl mx-auto">
            {t("banner.title_pre")} <em className="italic text-[#D1BFAe]">{t("banner.title_em")}</em>
            {t("banner.title_dot")}
          </h2>
          <p className="mt-8 max-w-xl mx-auto text-white/80 font-light leading-relaxed">
            {t("banner.body")}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
